<template>
  <el-dialog :title="title" :visible.sync="dialogVisible" :close-on-click-modal="false" append-to-body width="400px">
    <div v-if="hasRadish">
      <p class="warning-text">该公司已有此人选是否加入该公司HR联系人，并标注相应职能模块</p>
      <div class="card-content-item">
        <span class="field-label">姓名</span>
        <el-input v-model="newRadish.姓名" placeholder="姓名" size="mini" />
      </div>
    </div>
    <div v-else>
      <div class="card-content-item">
        <span class="field-label"><span class="require-field">*</span>姓名</span>
        <el-input v-model="newRadish.姓名" placeholder="姓名" size="mini" />
      </div>
      <div>
        <p class="field-alert "><span class="require-field">*</span>为保障数据查重，手机、邮箱、座机至少填写一项</p>
      </div>
    </div>

    <div class="card-content-item">
      <span class="field-label">手机</span>
      <el-input v-model="newRadish.手机" placeholder="输入手机号，自动查重" size="mini" @blur="duplicateRadish" />
    </div>
    <div class="card-content-item">
      <span class="field-label">邮箱</span>
      <el-input v-model="newRadish.邮箱" placeholder="输入邮箱，自动查重" size="mini" @blur="duplicateRadish" />
    </div>
    <div class="card-content-item">
      <span class="field-label">座机</span>
      <el-input v-model="newRadish.座机" placeholder="输入座机，自动查重" size="mini" @blur="duplicateRadish" />
    </div>
    <div class="card-content-item">
      <span class="field-label">公司</span>
      <el-input v-model="newRadish.公司" placeholder="输入公司简称" size="mini" />
    </div>
    <div class="card-content-item">
      <span class="field-label">目前职位</span>
      <el-input v-model="newRadish.目前职位" placeholder="输入人选目前职位" size="mini" />
    </div>
    <div class="card-content-item">
      <span class="field-label">职级</span>
      <el-select v-model="newRadish.职级" class="field-value" filterable size="mini">
        <el-option v-for="(val, key) in rankOption" :key="key" :label="`${key}:${val}`" :value="key"></el-option>
      </el-select>
    </div>
    <div class="card-content-item">
      <span class="field-label">职能模块</span>
      <el-select v-model="newRadish.职能模块" class="field-value" multiple filterable size="mini">
        <el-option v-for="item in categories" :key="item.名称" :value="item.名称"></el-option>
      </el-select>
    </div>
    <div class="card-content-item">
      <span class="field-label">细分职能</span>
      <el-select v-model="newRadish.细分职能" class="field-value" multiple filterable size="mini">
        <el-option v-for="item in xifen" :key="item" :value="item"></el-option>
      </el-select>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="confirm">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import * as fixedvariant from '../../../../company/statistics/variant/fixedvariant'
import { defaultCompany } from '../../constant/defaultData'

export default {
  props: {
    title: { type: String, default: '添加人选' },
  },
  data() {
    return {
      dialogVisible: false,
      newRadish: {},
      rankOption: fixedvariant.职级2描述,
      hasRadish: null,
    }
  },
  computed: {
    categories() {
      return app.categories
    },
    xifen() {
      const arr = (app.categories || []).filter(
        v => this.newRadish.职能模块 && this.newRadish.职能模块.includes(v.名称),
      )
      const cate = []
      arr.forEach(v => cate.push(...(v.二级职能 || [])))
      return [...new Set(cate)]
    },
  },
  methods: {
    open(defaultRadish) {
      this.newRadish = defaultRadish || {}
      this.hasRadish = null
      this.dialogVisible = true
    },
    async confirm() {
      if (this.newRadish._id) {
        this.modifyRadish()
      } else {
        await this.insertRadish()
      }
      this.$emit('confirm', this.newRadish)
      this.dialogVisible = false
    },
    async modifyRadish() {
      if (!this.newRadish.职能模块.includes('HR-人力')) {
        this.newRadish.职能模块.push('HR-人力')
      }
      const option = window._.cloneDeep(this.newRadish)
      delete option._id
      const res = await window.app.service('radish').modifyById({ _id: this.newRadish._id, data: option })
      if (res.status === 'success') this.$message('修改成功')
    },
    async insertRadish() {
      const radish = this.newRadish
      radish.from = 'addRadishDialog'
      const res = await window.app.service('radish').insert(radish)
      if (res.status === 'success') {
        this.newRadish._id = res.data.id
        this.$message.success(`添加成功`)
      } else {
        this.$message.error(`${res.msg}`)
      }
    },
    async duplicateRadish() {
      const radish = this.newRadish
      const fields = ['手机', '邮箱', '座机']
      const query = {}
      let dupField = ''
      fields.forEach(field => {
        if (radish[field] && Object.keys(query).length === 0) {
          query[field] = radish[field]
          dupField = field
        }
      })
      if (Object.keys(query).length === 0) return

      const res = await app.service('radish').simpleList({
        query: query,
        fields: { 姓名: 1, 手机: 1, 邮箱: 1, 座机: 1, 公司: 1, 目前职位: 1, 职级: 1, 职能模块: 1, 细分职能: 1 },
      })
      if (res.status === 'success') {
        if (res.data.length > 0) {
          const findRadish = res.data[0]
          if (!findRadish.职能模块) findRadish.职能模块 = []
          if (!findRadish.细分职能) findRadish.细分职能 = []
          this.hasRadish = res.data[0]
          this.newRadish = res.data[0]
          this.$message.error(`${dupField}字段重复`)
        } else if (this.newRadish._id) delete this.newRadish._id
      }
    },
  },
}
</script>
<style scoped src="../../css/newProjectDetail.css"></style>
<style scoped>
.warning-text {
  color: #f56c6c;
}
</style>
